import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import type { BankFindInterface } from '@zaoblako/shared/modules/catalog/dtos/bank/bank-find.dto';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';

@Component({
  standalone: true,
  selector: 'crm-bank-auto-complete',
  templateUrl: './bank-auto-complete.component.html',
  imports: [CommonModule, AutoCompleteComponent, SafeHtmlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankAutoCompleteComponent {
  @ViewChild('bankAutoComplete', { static: true }) public bankAutoComplete: AutoCompleteComponent;

  @Input() public selectedBank: BankFindInterface;
  @Output() public selectedBankChange = new EventEmitter<BankFindInterface>();

  @Input() public banks: BankFindInterface[] = [];
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public appendTo: string;

  @Output() public bankSearch = new EventEmitter<string>();

  public toBank(bank: any): BankFindInterface {
    return bank as BankFindInterface;
  }

  public highlightMatchText(text: string): string {
    return HighlightMatchTextHelper.highlightMatchText(text, this.bankAutoComplete?.autoComplete?.inputValue());
  }
}
